module.exports = __webpack_public_path__ + "img/ill-home-services-web-hosting.ae77db69.svg";